export default __webpack_public_path__ + "static/media/triangle-pattern_cri-070.17632b4f.jpg";